import {getAbsoluteUrl} from "../../utils/urlUtill";

export function handle403() {
    window.location.href = getAbsoluteUrl('login');
}

export const global_403_handler_factory: angular.IHttpInterceptorFactory = function () {
    return {
        responseError: (response) => {
            if (response.status === 403) {
                handle403();
            }
            return response;
        }
    }
};
